// src/context/TooltipContext.js
import { createContext, useState, useEffect } from "react";

export const TooltipContext = createContext();

export const TooltipProvider = ({ children }) => {
  const [tooltipsEnabled, setTooltipsEnabled] = useState(() => {
    return localStorage.getItem("tooltips") !== "off";
  });

  const toggleTooltips = () => {
    setTooltipsEnabled((prev) => {
      const next = !prev;
      localStorage.setItem("tooltips", next ? "on" : "off");
      return next;
    });
  };

  useEffect(() => {
    document.body.classList.toggle("tooltips-off", !tooltipsEnabled);
  }, [tooltipsEnabled]);

  return (
    <TooltipContext.Provider value={{ tooltipsEnabled, toggleTooltips }}>
      {children}
    </TooltipContext.Provider>
  );
};
